<template>
  <div class="component-goodsItem" :class="{ noPaddingLeft: isEdit }">
    <div class="select-wrap" v-if="isEdit" @click="handleSelectItem()">
      <img class="icon-select" :src="item.isSelected ? selectedIcon : unSelectIcon" />
    </div>
    <div class="pic-wrap" @click="handleClickItem()">
      <img class="pic" :src="formatHttpImg(item.picUrl)" />
    </div>
    <div class="content" @click="handleClickItem()">
      <!-- 产品名称 -->
      <p class="name">
        <span :class="`shop-source ${item.source === '淘宝' ? 'taobao' : 'tmall'}`">{{ item.source }}</span>
        {{ item.title }}
      </p>
      <!-- 价格信息 -->
      <div class="price">
        <div class="actPrice">
          <span class="unit">¥</span>
          <span class="money">{{ formatStrAmount(item.buyPrice) }}</span>
        </div>
        <span class="tagPrice">{{ `¥${formatStrAmount(item.marketPrice)}` }}</span>
      </div>
      <!-- 销量 -->
      <div class="sale-volume" v-if="item.hasOwnProperty('salesVolume')">{{ item.salesVolume }}人已购买</div>
      <div class="tag-wap" v-if="item.couponAmount > 0 || item.sharePrice > 0" :style="`${item.hasOwnProperty('salesVolume') ? 'margin-top:0.08rem' : 'margin-top:0.48rem'}`">
        <!-- 优惠券 -->
        <span class="btn-tag tag-coupon" v-if="item.couponAmount > 0">{{ item.couponAmount }}元券</span>
        <!-- 推广收益 -->
        <div class="btn-tag tag-shareMoney" v-if="item.sharePrice > 0">推广收益:¥{{ item.sharePrice }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import LocalStore from '@/utils/localStore'
import Consts from '@/common/consts'
export default {
  name: 'singleGoodsItem',
  props: {
    item: {
      type: Object,
      default: function() {
        return {}
      },
    },
    isSearchPage: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    channel: {
      type: String,
      default: 'tbk'
    }
  },
  data() {
    return {
      selectedIcon: require('../assets/images/icon_selected.png'),
      unSelectIcon: require('../assets/images/icon_unselect.png'),
    }
  },
  methods: {
    handleClickItem() {
      let queryParams = { goodsId: this.item.goodsId, channel: this.channel }
      if (this.isSearchPage && this.channel === 'tbk') {
        // 来源于搜索页面
        queryParams['from'] = 'search'
        LocalStore.set(Consts.STORE_SEARCH_GOODS_DATA, this.item)
      }
      this.$router.push({ name: 'productDetail', query: queryParams })
    },
    /**
     * 点击选择
     */
    handleSelectItem() {
      this.$emit('select')
    }
  },
}
</script>
<style lang="scss" scoped>
.component-goodsItem {
  position: relative;
  display: flex;
  padding: 0.2rem;
  background: #fff;
  box-sizing: border-box;
  &:not(:last-child) {
    border-bottom: 0.02rem solid #eeefef;
  }
  &.noPaddingLeft {
    padding-left: 0;
  }
  .select-wrap {
    // 选择
    display: flex;
    align-items: center;
    justify-content: center;
    width: 0.8rem;
    height: 2.2rem;
    margin-right: 0.06rem;
    .icon-select {
      display: inline-block;
      width: 0.4rem;
      height: 0.4rem;
    }
  }
  .pic-wrap {
    width: 2.2rem;
    height: 2.2rem;
    .pic {
      width: 100%;
      height: 100%;
      border-radius: 0.08rem;
    }
  }
  .content {
    flex: 1;
    margin-left: 0.24rem;
    min-width: 0; // 解决flex遇上white-space: nowrap引起样式冲突
    .name {
      position: relative;
      height: 0.8rem;
      line-height: 0.4rem;
      color: #333;
      font-size: 0.26rem;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      .shop-source {
        display: inline-block;
        padding: 0.02rem 0.06rem;
        font-size: 0.2rem;
        margin-right: 0.04rem;
        line-height: 0.24rem;
        box-sizing: border-box;
        &.tmall {
          // 天猫
          border: 0.01rem solid #ff0036;
          color: #ff0036;
        }
        &.taobao {
          border: 0.01rem solid #fe9320;
          color: #fe9320;
        }
      }
    }
    .price {
      display: flex;
      align-items: flex-end;
      margin-top: 0.06rem;
      height: 0.4rem;
      vertical-align: bottom;
      .actPrice {
        // 销售价, 实际价
        display: inline-block;
        color: #f42f19;
        height: 0.4rem;
        line-height: 0.48rem;
        .unit {
          font-size: 0.3rem;
          font-weight: 500;
          height: 0.32rem;
          line-height: 0.32rem;
          transform: scale(0.857);
          transform-origin: center left;
        }
        .money {
          font-size: 0.38rem;
          height: 0.38rem;
          font-weight: 500;
        }
      }
      .tagPrice {
        // 标签价
        margin-left: 0.2rem;
        display: inline-block;
        color: #999;
        font-size: 0.3rem;
        height: 0.3rem;
        transform: scale(0.857);
        transform-origin: center left;
        text-decoration: line-through;
      }
    }
    .sale-volume {
      // 销量
      height: 0.4rem;
      line-height: 0.4rem;
      margin-top: 0.16rem;
      color: #aaa;
      font-size: 0.24rem;
    }
    .tag-wap {
      display: flex;
      align-items: center;
      margin-top: 0.08rem;
      .btn-tag {
        display: inline-block;
        line-height: 0.24rem;
        padding: 0.03rem 0.1rem;
        text-align: center;
        border-radius: 0.04rem;
        font-size: 0.2rem;
        &.tag-coupon {
          // 优惠券
          background: #f42f19;
          color: #fff;
        }
        &.tag-shareMoney {
          // 推广收益
          margin-left: auto;
          background: rgb(255, 234, 234);
          color: #f42f19;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
